export const EASE = [0.16, 1, 0.3, 1];
